export enum DiscountType {
  DOLLAR = 'Dollar',
  PERCENT = 'Percent'
}
